<template>
  <main class="p-4 border h-100">
    <b-row class="mb-4">
      <b-col class="md-6">
        <h4 class="font-weight-bolder" v-once>Fiscais Técnicos</h4>
      </b-col>
      <b-col class="md-6">
        <b-form-checkbox v-model="isFiscalsFilterOn" switch>
          Fiscais sem processos vinculados
        </b-form-checkbox>
      </b-col>
    </b-row>
    <TabelaFiscais :data="toggleTableData" />
  </main>
</template>
<script>
import TabelaFiscais from '../../components/TabelaFiscais.vue';
export default {
  components: { TabelaFiscais },
  data() {
    return {
      tableData: [{ name: 'Carregando...', processos_count: 0 }],
      modalData: {
        name: '',
      },
      isFiscalsFilterOn: false,
      filteredTableData: [],
    };
  },
  methods: {
    toggleModal(fiscalName) {
      this.modalData.name = fiscalName;
      this.$bvModal.show('modal-tecnico');
    },
    async fetchFiscals() {
      try {
        const response = await this.$http.get('fiscais?fiscal_tecnico=true');
        this.tableData = response.data[0].map(fiscal => {
          const fiscalMapped = {
            id: fiscal.id,
            name: fiscal.name,
            processos_count: fiscal.processos_count,
          };
          return fiscalMapped;
        });
      } catch (error) {
        this.$swal({
          title:
            'Erro ao listar os Fiscais Técnicos! Tente recarregar a página!',
          icon: 'error',
        });
      }
    },
  },
  computed: {
    toggleTableData() {
      return this.isFiscalsFilterOn ? this.filteredTableData : this.tableData;
    },
  },
  async mounted() {
    await this.fetchFiscals();
    this.filteredTableData = this.tableData.filter(
      fiscal => fiscal.processos_count === 0
    );
  },
  //If user doesn't have permission to view this page, redirect to '/processos/minha-unidade'
  beforeCreate() {
    if (!this.$helper.verificaPermissao('visualizar_menu_fiscais')) {
      this.$router.push('/processos/minha-unidade');
    }
  },
};
</script>
